export enum PatientTypeStatusEnum {
    Expired = 0,
    None = 1,
    BirthDate = 2,
    CPF = 3,
    MotherName = 4
}